import uploadspracticeAreaspagebannerPracticeAreabgimageshutterstock_1092700045FirstFrameJpg from "$lib/data/generated/uploads/practice areas/PageBanner Practice Area/bgImage/shutterstock_1092700045-first-frame.jpg";

export const uploads = {
  "uploads/practice areas/PageBanner Practice Area/bgImage/shutterstock_1092700045-first-frame.jpg": uploadspracticeAreaspagebannerPracticeAreabgimageshutterstock_1092700045FirstFrameJpg
};